import SearchBar from './SearchBar.jsx';

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/index.js